import { render } from "./UserPlaylists.vue?vue&type=template&id=45fcf8d7"
import script from "./UserPlaylists.vue?vue&type=script&lang=js"
export * from "./UserPlaylists.vue?vue&type=script&lang=js"
script.render = render

export default script